import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

import { HomeComponent } from './home.component';
import { Shell } from '@app/shell/shell.service';
import { DomainGuard } from '@app/@shared/guards/domain.guard';

const routes: Routes = [Shell.childRoutes([{ path: '', component: HomeComponent, data: { page: 'home' },canActivate: [DomainGuard] }])];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class HomeRoutingModule {}
